import { ReflectionBase } from './reflection-base'
import { StructureCodeEnum } from './structure-code-enum'
import { StructureStatusEnum } from './structure-status-enum'
import { StructureTranslations } from './structure-translations'
import { StructureTypeEnum } from './structure-type-enum'

export interface StructureInterface {
  /**
   * 序号
   */
  seq: number
  /**
   * 结构名称
   */
  name: string
  /**
   * 内部代码
   */
  code?: StructureCodeEnum | null
  /**
   * 结构路径
   */
  path: string
  /**
   * 结构深度
   */
  depth: number
  /**
   * 排序权重
   */
  weight: number
  /**
   * 结构类型
   */
  type: StructureTypeEnum
  /**
   * 科目ID列表
   */
  subjectIds?: number[] | null
  /**
   * 管理员用户ID列表
   */
  managerIds?: number[] | null
  /**
   * 关联资源ID
   */
  relatedId?: number | null
  /**
   * 当前学期 grade_maps 中，当前年级对应的届别 term ID
   * 仅 type=grade 且 grade_maps 有匹配时有值
   */
  graduatesInId?: number | null
  /**
   * 外部系统ID
   */
  outerId?: string | null
  /**
   * 结构状态
   */
  status: StructureStatusEnum
  /**
   * 创建人ID
   */
  createdBy?: number | null
  /**
   * 更新人ID
   */
  updatedBy?: number | null
  /**
   * 父级结构
   */
  parent?: Structure | null
  /**
   * 子级结构
   */
  children?: Structure[]
  /**
   * 管理员列表
   */
  managers?: ReflectionBase[]
  /**
   * 翻译列表
   */
  translations?: StructureTranslations | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Structure implements StructureInterface {
  /**
   * 序号
   */
  seq: number
  /**
   * 结构名称
   */
  name: string
  /**
   * 内部代码
   */
  code?: StructureCodeEnum | null
  /**
   * 结构路径
   */
  path: string
  /**
   * 结构深度
   */
  depth: number
  /**
   * 排序权重
   */
  weight: number
  /**
   * 结构类型
   */
  type: StructureTypeEnum
  /**
   * 科目ID列表
   */
  subjectIds?: number[] | null
  /**
   * 管理员用户ID列表
   */
  managerIds?: number[] | null
  /**
   * 关联资源ID
   */
  relatedId?: number | null
  /**
   * 当前学期 grade_maps 中，当前年级对应的届别 term ID
   * 仅 type=grade 且 grade_maps 有匹配时有值
   */
  graduatesInId?: number | null
  /**
   * 外部系统ID
   */
  outerId?: string | null
  /**
   * 结构状态
   */
  status: StructureStatusEnum
  /**
   * 创建人ID
   */
  createdBy?: number | null
  /**
   * 更新人ID
   */
  updatedBy?: number | null
  /**
   * 父级结构
   */
  parent?: Structure | null
  /**
   * 子级结构
   */
  children?: Structure[]
  /**
   * 管理员列表
   */
  managers?: ReflectionBase[]
  /**
   * 翻译列表
   */
  translations?: StructureTranslations | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: StructureInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      seq: _seq,
      name: _name,
      code: _code,
      path: _path,
      depth: _depth,
      weight: _weight,
      type: _type,
      subjectIds: _subjectIds,
      managerIds: _managerIds,
      relatedId: _relatedId,
      graduatesInId: _graduatesInId,
      outerId: _outerId,
      status: _status,
      createdBy: _createdBy,
      updatedBy: _updatedBy,
      parent: _parent,
      children: _children,
      managers: _managers,
      translations: _translations,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.seq = _seq
    this.name = _name
    this.code = _code
    this.path = _path
    this.depth = _depth
    this.weight = _weight
    this.type = _type
    this.subjectIds = _subjectIds
    this.managerIds = _managerIds
    this.relatedId = _relatedId
    this.graduatesInId = _graduatesInId
    this.outerId = _outerId
    this.status = _status
    this.createdBy = _createdBy
    this.updatedBy = _updatedBy
    this.parent = _parent ? new Structure(_parent) : _parent
    this.children = _children
      ? _children.map((i) => new Structure(i))
      : _children
    this.managers = _managers
      ? _managers.map((i) => new ReflectionBase(i))
      : _managers
    this.translations = _translations
      ? new StructureTranslations(_translations)
      : _translations
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
